//Imports
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import Tabs, { TabContainer } from 'Components/Tabs';

//Controls
import {
  Form,
  Input,
  Select,
  InputNumeric,
  DatePicker,
  Button, 
  Modal
} from "@gpstrackit/gtc-react-controls";

import {  Input as InputComponent } from "Components";

import { Divider, Grid, Box, Typography } from '@mui/material';
import { HasPermission } from 'Core/security';
import { GetFormatForMoment, cleanString, cleanLicensePlate } from 'Core/data/Helpers';

//Components
import {
    NotificationManager,
    NotificationContainer,
} from "Components/Notifications";

import {  vinValidation } from 'Core/data/Helpers';

//Hooks
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";

//Actions
import { assetCreateEditSearchEntityLists, reset, assetGetAsset, assetCreateEditSearchAssetSubtypes, assetUpdateAsset,  assetCreateAsset, assetTypeSearchEntityLists, assetDecodeVin } from "./redux/slice";

//Styles
import "./index.scss";
import TagsManage from "../../../../../.common/components/TagsManage";



let INIT_STATE = {
    label: null,
    assetType: null,
    assetSubType: null,
    licensePlate: null,
    registrationCountry: null,
    registrationExpiration: null,
    registrationState: null,
    vin: null,
    make: null,
    model: null,
    year: null,
    engine: null,
    mpgHighway: null,
    mpgCity: null,
    inspectionDeviceType: null,
    inspectionTagId: null,
    tags: [],
    isActive: null,
    maintenanceCompany: null,
    chassisSerialNumber: null,
    engineSerialNumber: null,
    vehicleId: null,
    powerUnitNumber: null
    
}

const sections = Object.freeze({
  LICENSE_PLATE: 'licensePlate',
  MAINTENANCE: 'maintenance',
  REGISTRATION: 'registration',
  CHASSIS_SERIAL_NUMBER: 'chassisSerialNumber',
  ENGINE_SERIAL_NUMBER: 'engineSerialNumber',
  VEHICLE_ID: 'vehicleId',
  MPG: 'mpg',
  EVIR: 'evir',
  ZONAR_ELD: 'zonarEld',
});

const CounterString = ({ string, maxLength }) => {
  const stringValue = String(string ?? '');
  return (
    <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', width: '100%' }}>
      <Typography style={{ fontSize: 12, color: '#666' }}>
        {stringValue?.length} / {maxLength}
      </Typography>
    </Box>
  );
};



const CreateEditAsset = ({ refresh }) => {

    //Redux
    const dispatch = useDispatch();
    const { 
        open, 
        loading, 
        result, 
        error, 
        entityLists, 
        assetId, 
        loadingAsset, 
        asset, 
        loadingDecodeVin, 
        deviceVin,    
        loadingEntityLists,
        loadingAssetSubtypes, 
        assetSubtypes,
        assetTypeEntityLists, 
        loadingAssetTypeConfig,
     } = useSelector((state) => state.manageAssetCreateEditRedux);

    // const { assetTypeEntityLists, loadingAssetTypeConfig } = useSelector((state) => state.assetTypeSearchEntityListsSlice);
          const user = useSelector((state) => state.securityRedux.user);

    //Local States
    const [tab, setTab] = useState(0);
    const [formData, setFormData] = useState(INIT_STATE);
    const [changes, setChanges] = useState(INIT_STATE);


    const [countryOptions, setCountryOptions] = useState([]);
    const [stateOptions, setStateOptions] = useState([]);

    const newRef =  Form.useForm();

    //Ref
    const createEditAssetFormRef = {
        ...newRef,
        setValue: (field, value) => {
            setFormData((prev) => ({ ...prev, [field]: value }));
        }
    }
    //Language
    const { messages } = useIntl();

    //Handlers and utils
    const handleClose = useCallback(() => {
        dispatch(reset());
    }, []);


    const nextYear = new Date().getFullYear() + 1;

    const toAWSDate = (v) => {
        if (!v) return null;                
        const d = v instanceof Date ? v : new Date(v);
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        return `${y}-${m}-${day}`;      
    };

    

    const handleSubmit = (values) => {
        const isEditing = !!assetId;
        let payload = {};

        let tagIds = formData?.tags.length ? formData?.tags?.map((tag) => tag?.id) : [];
        const isRegistrationStateDisabled = ['CO', 'PE', 'NONE'].includes(values?.registrationCountry?.entityId);

        const isRegistrationStateMissing = (
            HasPermission(user, 'zlogs') &&
            values?.registrationCountry?.entityId &&
            values?.registrationCountry?.entityId !== 'NONE' &&
            !isRegistrationStateDisabled &&
            (!values?.registrationState?.entityId || values?.registrationState?.entityId === 'NONE')
        );

        if (isRegistrationStateMissing) {
            NotificationManager.warning(
                messages['manage_createEditAsset_registrationRequired'],
                messages["error"],
                3000
            );

            return false;
        }
        
        if (changes?.vin && values?.vin && !vinValidation(values.vin)) {
            NotificationManager.warning(
                messages['manage_createEditAsset_errorVin'],
                messages["error"],
                3000
            );
        }
        


        if (isEditing) {
            if (changes.licensePlate && values?.licensePlate && values?.licensePlate?.length < 4) {
                NotificationManager.error(
                    messages['manage_createEditAsset_licensePlateErrorLength'],
                    messages["error"],
                    3000
                );
                return;
            } 

            payload = {
                id: assetId,
                ...(changes.label && { label: values?.label || '' }),
                ...(changes.assetType && { assetTypeId: values?.assetType?.entityId }),
                ...(changes.assetSubtype && { assetSubtypeId: values?.assetSubtype?.id }),
                ...(changes.licensePlate && { licensePlate: values?.licensePlate || '' }),
                ...(changes.registrationCountry && { registrationCountry: values?.registrationCountry?.entityId === "NONE" ? "" : values?.registrationCountry?.entityId || '' }),
               ...(changes.registrationExpiration && { registrationExpiration: values?.registrationExpiration ? toAWSDate(values?.registrationExpiration) : '' }),
                ...(changes.registrationState && { registrationState: values.registrationState?.entityId === "NONE" ? "" : values?.registrationState?.entityId || '' }),
                ...(changes.vin && { vin: values?.vin || '' }),
                ...(changes.make && { make: values?.make || '' }),
                ...(changes.model && { model: values?.model || '' }),
                ...(changes.year && { year: values?.year || 0 }),
                ...(changes.engine && { engine: values?.engine ? parseFloat(values?.engine) : 0 }),
                ...(changes.mpgHighway && { mpgHighway: values?.mpgHighway || 0 }),
                ...(changes.mpgCity && { mpgCity: values?.mpgCity || 0 }),
                ...(changes.inspectionDeviceType && { inspectionDeviceType: values?.inspectionDeviceType?.entityId || '' }),
                ...(changes.inspectionTagId && { inspectionTagId: values?.inspectionTagId || '' }),
                ...(changes.powerUnitNumber && { powerUnitNumber: values?.powerUnitNumber || '' }),
                ...(changes.tags && { tagIds: tagIds }),
                ...(changes.externalId && { externalId: values?.externalId || '' }),
                ...(changes.isActive && { isActive: values?.isActive?.id }),
                ...(changes.chassisSerialNumber && { chassisSerialNumber: values?.chassisSerialNumber || '' }),
                ...(changes.engineSerialNumber && { engineSerialNumber: values?.engineSerialNumber || '' }),
                ...(changes.maintenanceCompany && { maintenanceCompany: values?.maintenanceCompany?.id || values?.maintenanceCompany || '' })
            }

            dispatch(assetUpdateAsset(payload))
        } else {
            if (values?.licensePlate && values?.licensePlate?.length < 4) {
                NotificationManager.error(
                    messages['manage_createEditAsset_licensePlateErrorLength'],
                    messages["error"],
                    3000
                );
                return;
            } 

            payload = {
                label: values?.label,
                assetTypeId: values?.assetType?.entityId,
                assetSubtypeId: values?.assetSubtype?.id,
                licensePlate: values?.licensePlate,
                registrationCountry: values?.registrationCountry?.entityId === "NONE" ? "" : values?.registrationCountry?.entityId,
                registrationExpiration: values?.registrationExpiration ? toAWSDate(values?.registrationExpiration) : "",
                registrationState: values?.registrationState?.entityId === "NONE" ? "" : values?.registrationState?.entityId,
                vin: values?.vin || "",
                make: values?.make || "",
                model: values?.model || "",
                year: values?.year || 0,
                engine: values?.engine ? parseFloat(values?.engine) : 0,
                mpgHighway: values?.mpgHighway || 0,
                mpgCity: values?.mpgCity || 0,
                inspectionDeviceType: values?.inspectionDeviceType?.entityId || "",
                inspectionTagId: values?.inspectionTagId || "",
                powerUnitNumber: values?.powerUnitNumber || "",
                tagIds: tagIds,
                externalId: values?.externalId || "",
                isActive: values?.isActive?.id,
                chassisSerialNumber: values?.chassisSerialNumber || "",
                engineSerialNumber: values?.engineSerialNumber || "",
                maintenanceCompany: values?.maintenanceCompany?.id || values?.maintenanceCompany || "",
            }
            dispatch(assetCreateAsset(payload))
        }
    }

    const handleSuccess = () => {
        let message = assetId ? messages["manage_createEditAsset_successMessageUpdate"] : messages["manage_createEditAsset_successMessageCreate"];
        NotificationManager.success(
            message,
            messages["success"],
            3000
        );
        refresh();
        handleClose();
    };

    //Effects
    useEffect(() => {
        if (open) {
            setChanges(INIT_STATE);
            dispatch(assetCreateEditSearchEntityLists({}))
            dispatch(assetCreateEditSearchAssetSubtypes({}));
        }
        if (assetId) {
            dispatch(assetGetAsset({ id: assetId }));
        }
    }, [open, assetId]);

    useEffect(() => {
        if (!open || !assetId) return;

        const noConfig =
            !assetTypeEntityLists ||
            (Array.isArray(assetTypeEntityLists?.items) && assetTypeEntityLists.items.length === 0) ||
            (Array.isArray(assetTypeEntityLists) && assetTypeEntityLists.length === 0);

        if (!noConfig) return;

        const assetTypeLabel =
            asset?.assetType?.label ||
            entityLists?.find(it => it?.entityName === "AssetType" && it?.entityId === asset?.assetTypeId)?.label;

        if (assetTypeLabel) {
            dispatch(assetTypeSearchEntityLists({ label: assetTypeLabel }));
        }
    }, [open, assetId, asset, entityLists, assetTypeEntityLists, dispatch]);

    useEffect(() => {
        if (result) {
            handleSuccess()
        }

        if (deviceVin?.error) {
            NotificationManager.error(
                messages["manage_createEditAsset_noInformationFoundVIN"],
                messages["error"],
                3000
            );
            dispatch(reset({ deviceVin: null }));
        } else if (deviceVin) {
            createEditAssetFormRef.setValues({
                year: deviceVin?.ModelYear,
                make: deviceVin?.Make,
                model: deviceVin?.Model,
                engine: deviceVin?.DisplacementL
            })
            setFormData({
                ...formData,
                year: deviceVin?.ModelYear,
                make: deviceVin?.Make,
                model: deviceVin?.Model,
                engine: deviceVin?.DisplacementL
            })
            setChanges({ ...changes, year: true, make: true, model: true, engine: true })
            dispatch(reset({ deviceVin: null }));
        }

        if (error) {
            let currentError = error?.error || messages["errorMessage"];
            if (currentError.includes("Label duplicated")) {
                currentError = messages['manage_createEditAsset_duplicatedLabel'];
            } else if (currentError.includes("License Plate duplicated") || currentError.includes("assets.IX_assets_licensePlate_unique")) {
                currentError = messages['manage_createEditAsset_duplicatedlicensePlace'];
            } else if (currentError.includes("VIN duplicated")) {
                currentError = messages['manage_createEditAsset_duplicatedVin'];
            } else if (currentError.includes("The VIN is not valid")) {
                currentError = messages['manage_createEditAsset_errorVin'];
            } else if (currentError.includes("ExternalId duplicated")) {
                currentError = messages['manage_createEditAsset_duplicatedexternalId']
            } else if (currentError.includes("InspectionTagId duplicated") || currentError.includes("assets.IX_assets_inspectionTagId_unique")) {
                currentError = messages['manage_createEditAsset_duplicatedTagId']
            } else if (currentError.includes("ER_PARSE_ERROR")) {
                currentError = messages["errorMessage"];
            }

            NotificationManager.error(
                currentError,
                messages["error"],
                3000
            );
            dispatch(reset({ error: null }));
        }
    }, [result, error, deviceVin]);

    useEffect(() => {
        if (asset && entityLists?.length) {
            let currentRegistrationState = asset?.registrationState === "CO-" ? "CO-CO" : asset?.registrationState === "PE-" ? "PE-PE" : asset?.registrationState
            let registrationCountry = asset?.registrationCountry ? entityLists?.find((item) => item?.entityName === "COUNTRY" && item?.entityId === asset?.registrationCountry) : null
            let registrationState = asset?.registrationState ? entityLists?.find((item) => item?.entityName === "STATE" && item?.entityId === currentRegistrationState) : null
            let inspectionDeviceType = asset?.inspectionDeviceType ? entityLists?.find((item) => item?.entityName === "InspectionDeviceType" && item?.entityId === asset?.inspectionDeviceType) : null

            // Buscar assetType en entityLists si no viene completo
            let assetTypeObj = asset?.assetTypeId
                ? (asset?.assetType || entityLists?.find((item) => item?.entityName === "AssetType" && item?.entityId === asset?.assetTypeId))
                : null;

            let statusList = [{ id: true, name: messages['manage_createEditAsset_active'] }, { id: false, name: messages['manage_createEditAsset_inactive'] }]
            let currentStatus = statusList.find((item) => item.id === asset?.isActive) || { id: true, name: messages['manage_createEditAsset_active'] }

            registrationState = registrationState || { entityId: "NONE", label: messages['manage_createEditAsset_none'], parentId: "NONE" }
            registrationCountry = registrationCountry || { entityId: "NONE", label: messages['manage_createEditAsset_none'] }

            // Convert maintenanceCompany string to Select object
            const maintenanceCompanyOptions = [
                { id: 'No Maintenance Company', name: messages['manage_createEditAsset_maintenanceCompany_none'] },
                { id: 'Idealease', name: messages['manage_createEditAsset_maintenanceCompany_idealease'] },
                { id: 'Nationalease', name: messages['manage_createEditAsset_maintenanceCompany_nationalease'] },
                { id: 'Noregon', name: messages['manage_createEditAsset_maintenanceCompany_noregon'] },
                { id: 'Penske', name: messages['manage_createEditAsset_maintenanceCompany_penske'] },
                { id: 'Ryder', name: messages['manage_createEditAsset_maintenanceCompany_ryder'] },
                { id: 'Other Maintenance Company', name: messages['manage_createEditAsset_maintenanceCompany_other'] },
            ];
            let maintenanceCompanyValue = asset?.maintenanceCompany 
                ? maintenanceCompanyOptions.find(opt => opt.id === asset.maintenanceCompany) || null
                : null;

            createEditAssetFormRef.setValues({
                label: asset?.label || "",
                assetType: assetTypeObj,
                assetSubtype: asset?.assetSubtype || null,
                licensePlate: asset?.licensePlate,
                vin: asset?.vin,
                make: asset?.make,
                model: asset?.model,
                year: asset?.year,
                engine: asset?.engine,
                mpgHighway: asset?.mpgHighway,
                mpgCity: asset?.mpgCity,
                inspectionTagId: asset?.inspectionTagId,
                registrationCountry: registrationCountry,
                registrationExpiration: asset?.registrationExpiration ? new Date(asset?.registrationExpiration) : null,
                registrationState: registrationState,
                inspectionDeviceType: inspectionDeviceType,
                powerUnitNumber: asset?.powerUnitNumber,
                externalId: asset?.externalId,
                isActive: currentStatus,
                maintenanceCompany: maintenanceCompanyValue,
                chassisSerialNumber: asset?.chassisSerialNumber || "",
                engineSerialNumber: asset?.engineSerialNumber || ""

            })
            setFormData({
                tags: asset?.tags || [],
                registrationCountry: registrationCountry,
                registrationExpiration: asset?.registrationExpiration ? new Date(asset?.registrationExpiration) : null,
                registrationState: registrationState,
                licensePlate: asset?.licensePlate,
                isActive: currentStatus,

                //new
                label: asset?.label,
                assetType: assetTypeObj,
                externalId: asset?.externalId,
                vin: asset?.vin,
                make: asset?.make,
                model: asset?.model,
                year: asset?.year,
                engine: asset?.engine,
                mpgHighway: asset?.mpgHighway,
                mpgCity: asset?.mpgCity,
                inspectionTagId: asset?.inspectionTagId,
                powerUnitNumber: asset?.powerUnitNumber,
                maintenanceCompany: maintenanceCompanyValue,
                chassisSerialNumber: asset?.chassisSerialNumber || "",
                engineSerialNumber: asset?.engineSerialNumber || ""

            });
        }
    }, [asset, entityLists])


    useEffect(() => {
        if (!open || !Array.isArray(entityLists) || entityLists.length === 0) return;
        const isEntity = (type) => (item) => item?.entityName === type;
        const countries = entityLists.filter(isEntity("COUNTRY"));
        const states = entityLists.filter(isEntity("STATE"));
        setCountryOptions([{ entityId: "NONE", label: messages['manage_createEditAsset_none'] }, ...countries]);
        setStateOptions([{ entityId: "NONE", label: messages['manage_createEditAsset_none'], parentId: "NONE" }, ...states]);
    }, [entityLists, open]);

    useEffect(() => {
        if (open && !assetId) {
            setTimeout(() => {
                let currentState = { entityId: "NONE", label: messages['manage_createEditAsset_none'], parentId: "NONE" }
                let currentCountry = { entityId: "NONE", label: messages['manage_createEditAsset_none'] }
                let currentStatus = { id: true, name: messages['manage_createEditAsset_active'] }
                setFormData({
                    ...formData,
                    registrationState: currentState,
                    registrationCountry: currentCountry,
                    isActive: currentStatus
                });
                createEditAssetFormRef.setValues({
                    registrationState: currentState,
                    registrationCountry: currentCountry,
                    isActive: currentStatus
                })
            }, 500)
        }
    }, [open])

      const setForm = useCallback(
        (partial) => {
          setFormData((prev) => {
            const nextFormData = { ...prev, ...partial };
            createEditAssetFormRef.setValues(nextFormData);
            return nextFormData;
          });
        },
        [createEditAssetFormRef, setFormData]
      );
    
      const change = useCallback(
        (field, value) => {
          setChanges((prev) => ({ ...prev, [field]: true }));
          setForm({ [field]: value });
        },
        [setChanges, setForm]
      );
    
    
      const optionsIds = useCallback(
        (type) => {
          const item =
            assetTypeEntityLists?.items?.[0] || assetTypeEntityLists?.[0] || null;
          if (!item) return [];
    
          let arr = [];
          try {
            arr = Array.isArray(item.jsonValue)
              ? item.jsonValue
              : item.jsonValue
              ? JSON.parse(item.jsonValue)
              : [];
          } catch {
            arr = [];
          }
          if (!type) return [];
          if (type === 'visible') {
            return arr.filter((x) => x && x.section && x.visible === true).map((x) => x.section);
          } else {
            return arr
              .filter((x) => x && x.section && Array.isArray(x.requiredFields) && x.requiredFields.length > 0)
              .flatMap((x) => x.requiredFields);
          }
        },
        [assetTypeEntityLists]
      );
    
      const visibleSections = useMemo(() => optionsIds('visible'), [optionsIds]);
      const requiredFields = useMemo(() => optionsIds('required'), [optionsIds]);
    
      const isVisible = useCallback((section) => visibleSections.includes(section), [visibleSections]);
      const isRequired = useCallback((field) => requiredFields.includes(field), [requiredFields]);
    
      const registrationStateKey = formData?.registrationCountry?.entityId || 'no-country';
      const isRegistrationStateDisabled = ['CO', 'PE', 'NONE'].includes(formData?.registrationCountry?.entityId);


     const tabs = [
        {
            label: messages["manage_createEditAsset_asset"],
            icon: "settings",
            component: (
                    <div>
                      <Form.Item
                        name="externalId"
                        label={messages['manage_createEditAsset_externalId']}
                        className="asset-formItem"
                      >
                        <Input
                          id="externalId"
                          type="text"
                          placeholder={messages['manage_createEditAsset_enterExternalId']}
                          onChange={(value) => {
                            const cleanedValue = cleanString(value);
                            change('externalId', cleanedValue);
                            if (cleanedValue !== value) {
                              setTimeout(() => {
                                createEditAssetFormRef.setValues({ externalId: cleanedValue });
                              }, 100);
                            }
                          }}
                          maxLength={50}
                        />
                      </Form.Item>
                      <CounterString string={formData?.externalId || ''} maxLength={50} />
                
                      <Form.Item
                        name="label"
                        label={messages['manage_createEditAsset_label']}
                        rules={[{ required: true, message: messages['required_field'] }]}
                        className="asset-formItem"
                      >
                        <Input
                          id="label"
                          type="text"
                          placeholder={messages['manage_createEditAsset_placeholderLabel']}
                          onChange={(value) => {
                            const cleanedValue = cleanString(value);
                            change('label', cleanedValue);
                            if (cleanedValue !== value) {
                              setTimeout(() => {
                                createEditAssetFormRef.setValues({ label: cleanedValue });
                              }, 100);
                            }
                          }}
                          maxLength={50}
                        />
                      </Form.Item>
                      <CounterString string={formData?.label || ''} maxLength={50} />
                
                      <Form.Item name="isActive" label={messages['manage_createEditAsset_status']}>
                        <Select
                          id="isActive"
                          options={[
                            { id: true, name: messages['manage_createEditAsset_active'] },
                            { id: false, name: messages['manage_createEditAsset_inactive'] },
                          ]}
                          placeholder={messages['select']}
                          valueField="id"
                          textField="name"
                          style={{ width: '100%', fontFamily: '"Outfit", sans-serif' }}
                          onChange={(value) => change('isActive', value)}
                        />
                      </Form.Item>
                
                      <Form.Item
                        name="assetType"
                        label={messages['manage_createEditAsset_assetType']}
                        rules={[{ required: HasPermission(user, 'evir'), message: messages['required_field'] }]}
                      >
                        <Select
                          id="assetType"
                          options={entityLists?.filter((item) => item?.entityName === 'AssetType') || []}
                          placeholder={messages['select']}
                          valueField="entityId"
                          textField="label"
                          style={{ width: '100%', fontFamily: '"Outfit", sans-serif' }}
                          isSearchable
                          isLoading={loadingEntityLists}
                          onChange={(value) => {
                            const newTypeLabel = value?.label?.toUpperCase();
                            const isTrailerOrDolly = ['TRAILER', 'DOLLY'].includes(newTypeLabel);
                            const isStandard = newTypeLabel === 'STANDARD';

                            // Fields to clear based on asset type
                            const fieldsToClean = {};
                            const changesToUpdate = { assetType: true };

                            // For TRAILER and DOLLY: clear engine, MPG and VIN fields
                            if (isTrailerOrDolly) {
                              fieldsToClean.vin = '';
                              fieldsToClean.make = '';
                              fieldsToClean.model = '';
                              fieldsToClean.year = null;
                              fieldsToClean.engine = null;
                              fieldsToClean.engineSerialNumber = '';
                              fieldsToClean.mpgHighway = null;
                              fieldsToClean.mpgCity = null;
                              changesToUpdate.vin = true;
                              changesToUpdate.make = true;
                              changesToUpdate.model = true;
                              changesToUpdate.year = true;
                              changesToUpdate.engine = true;
                              changesToUpdate.engineSerialNumber = true;
                              changesToUpdate.mpgHighway = true;
                              changesToUpdate.mpgCity = true;
                            }

                            // For STANDARD: clear chassisSerialNumber
                            if (isStandard) {
                              fieldsToClean.chassisSerialNumber = '';
                              changesToUpdate.chassisSerialNumber = true;
                            }

                            setChanges((prev) => ({ ...prev, ...changesToUpdate }));
                            setForm({ assetType: value, ...fieldsToClean });
                            
                            // Actualizar también el formulario con los campos limpiados
                            if (Object.keys(fieldsToClean).length > 0) {
                              setTimeout(() => {
                                createEditAssetFormRef.setValues(fieldsToClean);
                              }, 100);
                            }
                            
                            dispatch(assetTypeSearchEntityLists({ label: value?.label }));
                          }}
                        />
                      </Form.Item>
                
                      <Form.Item
                        name="assetSubtype"
                        label={messages['manage_createEditAsset_assetSubtype']}
                        rules={[{ required: HasPermission(user, 'evir'), message: messages['required_field'] }]}
                      >
                        <Select
                          id="assetSubtype"
                          options={assetSubtypes || []}
                          placeholder={messages['select']}
                          valueField="id"
                          textField="name"
                          style={{ width: '100%', fontFamily: '"Outfit", sans-serif' }}
                          isSearchable
                          isLoading={loadingAssetSubtypes}
                          onChange={(value) => change('assetSubtype', value)}
                        />
                      </Form.Item>
                
                      {isVisible(sections.LICENSE_PLATE) && (
                        <>
                          <Form.Item
                            name="licensePlate"
                            label={messages['manage_createEditAsset_licensePlate']}
                            className="asset-formItem"
                            rules={[
                              { required: isRequired('licensePlate'), message: messages['required_field'] },
                              {
                                validator: (_, value) => {
                                  if (!value || value.length === 0) return Promise.resolve();
                                  if (value.length < 4 || value.length > 20) {
                                    return Promise.reject(new Error(messages['manage_createEditAsset_licensePlateErrorLength'] || 'License Plate must be between 1 and 20 characters'));
                                  }
                                  return Promise.resolve();
                                }
                              }
                            ]}
                          >
                            <Input
                              id="licensePlate"
                              type="text"
                              placeholder={messages['manage_createEditAsset_licensePlate']}
                              onChange={(value) => {
                                const cleanedValue = cleanLicensePlate(value);
                                change('licensePlate', cleanedValue);
                                if (cleanedValue !== value) {
                                  setTimeout(() => {
                                    createEditAssetFormRef.setValues({ licensePlate: cleanedValue });
                                  }, 100);
                                }
                              }}
                              maxLength={20}
                              minLength={4}

                            />
                          </Form.Item>
                          <CounterString string={formData?.licensePlate || ''} maxLength={20} />
                        </>
                      )}
                
                      {isVisible(sections.MAINTENANCE) && (
                        <>
                          <span style={{ fontWeight: 500, fontSize: 15 }}>{messages['manage_createEditAsset_maintenance']}</span>
                          <Divider style={{ marginBottom: 10 }} />
                           <Form.Item
                            name="maintenanceCompany"
                            label={messages['manage_createEditAsset_maintenanceCompany']}
                            rules={[{ required: isRequired('maintenanceCompany'), message: messages['required_field'] }]}
                          >
                            <Select
                              id="maintenanceCompany"
                              options={[
                                { id: 'No Maintenance Company', name: messages['manage_createEditAsset_maintenanceCompany_none'] },
                                { id: 'Idealease', name: messages['manage_createEditAsset_maintenanceCompany_idealease'] },
                                { id: 'Nationalease', name: messages['manage_createEditAsset_maintenanceCompany_nationalease'] },
                                { id: 'Noregon', name: messages['manage_createEditAsset_maintenanceCompany_noregon'] },
                                { id: 'Penske', name: messages['manage_createEditAsset_maintenanceCompany_penske'] },
                                { id: 'Ryder', name: messages['manage_createEditAsset_maintenanceCompany_ryder'] },
                                { id: 'Other Maintenance Company', name: messages['manage_createEditAsset_maintenanceCompany_other'] },
                              ]}
                              placeholder={messages['manage_createEditAsset_maintenanceCompany']}
                              valueField="id"
                              textField="name"
                              style={{ width: '100%', fontFamily: '"Outfit", sans-serif' }}
                              isSearchable
                              isClearable
                              onChange={(value) => change('maintenanceCompany', value)}
                            />
                          </Form.Item>
                        </>
                      )}
                
                      {isVisible(sections.REGISTRATION) && (
                        <>
                          <span style={{ fontWeight: 500, fontSize: 15 }}>{messages['manage_createEditAsset_registration']}</span>
                          <Divider style={{ marginBottom: 10 }} />
                          <Grid container spacing={2}>
                            <Grid item xs={6}>
                              <Form.Item
                                name="registrationCountry"
                                label={messages['manage_createEditAsset_registrationCountry']}
                                rules={[{ required: HasPermission(user, 'zlogs'), message: messages['required_field'] }]}
                              >
                                <Select
                                  id="registrationCountry"
                                  options={countryOptions || []}
                                  placeholder={messages['manage_createEditAsset_registrationCountry']}
                                  valueField="entityId"
                                  textField="label"
                                  style={{ width: '100%', fontFamily: '"Outfit", sans-serif' }}
                                  isSearchable
                                  isLoading={loadingEntityLists}
                                  onChange={(value) => {
                                    const isSpecial = ['CO', 'PE', 'NONE'].includes(value?.entityId);
                                    const newState = isSpecial
                                      ? stateOptions?.find((item) => item?.parentId == value?.entityId) ?? null
                                      : null;

                                    setChanges((prev) => ({
                                      ...prev,
                                      registrationCountry: true,
                                      registrationState: true,
                                    }));

                                    setForm({
                                      registrationCountry: value,
                                      registrationState: newState,
                                    });

                                  }}
                                />
                              </Form.Item>
                            </Grid>
                
                            <Grid item xs={6}>
                              <Form.Item
                                name="registrationState"
                                label={messages['manage_createEditAsset_registrationState']}
                                rules={[{
                                  required: !isRegistrationStateDisabled && (HasPermission(user, 'zlogs') || formData?.registrationCountry?.entityId !== "NONE"),
                                  message: messages['required_field']
                                }]}
                              >
                                <Select
                                  key={registrationStateKey}
                                  id="registrationState"
                                  options={
                                    formData?.registrationCountry
                                      ? stateOptions?.filter(
                                          (item) => item?.parentId == formData?.registrationCountry?.entityId
                                        )
                                      : stateOptions || []
                                  }
                                  placeholder={messages['manage_createEditAsset_registrationState']}
                                  valueField="entityId"
                                  textField="label"
                                  style={{ width: '100%', fontFamily: '"Outfit", sans-serif' }}
                                  isSearchable
                                  isLoading={loadingEntityLists}
                                  onChange={(value) => change('registrationState', value)}
                                  isDisabled={isRegistrationStateDisabled}
                                />
                              </Form.Item>
                            </Grid>
                          </Grid>
                
                          <Form.Item
                            name="registrationExpiration"
                            label={messages['manage_createEditAsset_registrationExpiration']}
                            rules={[{ required: isRequired('registrationExpiration'), message: messages['required_field'] }]}
                          >
                            <DatePicker
                              id="registrationExpiration"
                              showButtons
                              isClearable
                              showTimePicker={false}
                              calendarPosition="left"
                              placeholder={messages['manage_createEditAsset_registrationExpiration']}
                              format={GetFormatForMoment(user?.dateformat)}
                              onChange={(value) => {
                                const dateValue = value ? new Date(value) : null;
                                setChanges((prev) => ({ ...prev, registrationExpiration: true }));
                                setForm({ registrationExpiration: dateValue });
                              }}
                              minDate={new Date('2024-01-01T00:00:00')}
                            />
                          </Form.Item>
                        </>
                      )}
                
                      {isVisible(sections.CHASSIS_SERIAL_NUMBER) && formData?.assetType?.label?.toUpperCase() !== 'STANDARD'  && (
                        <>
                          <Form.Item
                            name="chassisSerialNumber"
                            label={messages['manage_createEditAsset_chassisSerialNumber']}
                            className="asset-formItem"
                            rules={[{ required: isRequired('chassisSerialNumber'), message: messages['required_field'] }]}
                          >
                            <InputComponent
                              id="chassisSerialNumber"
                              type="text"
                              placeholder={messages['manage_createEditAsset_chassisSerialNumber']}
                              maxLength={30}
                              regex={/^[A-Za-z0-9]*$/} 
                              className="asset-text-uppercase"
                              onChange={(value) => {
                                const raw = (value ?? '').toString();
                                const cleaned = raw.replace(/\s+/g, '').toUpperCase();
                                change('chassisSerialNumber', cleaned);
                              }}
                            />
                          </Form.Item>
                          <CounterString string={formData?.chassisSerialNumber || ''} maxLength={30} />
                        </>
                      )}
                
                      {isVisible(sections.ENGINE_SERIAL_NUMBER) && (
                        <>
                          {!['TRAILER', 'DOLLY'].includes(formData?.assetType?.label?.toUpperCase()) && (
                            <>
                              <Form.Item
                                name="engineSerialNumber"
                                label={messages['manage_createEditAsset_engineSerialNumber']}
                                className="asset-formItem"
                                rules={[{ required: isRequired('engineSerialNumber'), message: messages['required_field'] }]}
                              >
                                <InputComponent
                                  id="engineSerialNumber"
                                  type="text"
                                  placeholder={messages['manage_createEditAsset_engineSerialNumber']}
                                  className="asset-text-uppercase"
                                  maxLength={30}
                                  regex={/^[A-Za-z0-9]*$/} 
                                  onChange={(value) => {
                                    const raw = (value ?? '').toString();
                                    const cleaned = raw.replace(/\s+/g, '').toUpperCase();
                                    change('engineSerialNumber', cleaned);
                                  }}
                                />
                              </Form.Item>
                              <CounterString string={formData?.engineSerialNumber || ''} maxLength={30} />
                            </>
                          )}
                        </>
                      )}
                
                      {isVisible(sections.VEHICLE_ID) && (
                        <>
                          <span style={{ fontWeight: 500, fontSize: 15 }}>{messages['manage_createEditAsset_vehicleId']}</span>
                          <Divider style={{ marginBottom: 10 }} />
                
                          <Form.Item
                            name="vin"
                            label={messages['manage_createEditAsset_vin']}
                            className="asset-formItem"
                            rules={[
                              { required: isRequired('vin'), message: messages['required_field'] },
                              {
                                validator: (_, value) => {
                                  if (!value || value.length === 0) return Promise.resolve();
                                  // VIN warning: debe tener 17 caracteres y no contener I, O, o Q
                                  const isValidLength = value.length === 17;
                                  const hasInvalidChars = /[IOQ]/i.test(value);
                                  if (!isValidLength || hasInvalidChars) {
                                    // Warning level - permite guardar pero muestra advertencia
                                    return Promise.resolve();
                                  }
                                  return Promise.resolve();
                                },
                                warningOnly: true
                              }
                            ]}
                          >
                            <Input
                              id="vin"
                              type="text"
                              placeholder={messages['manage_createEditAsset_vin']}
                              onChange={(value) => {
                                const cleanedValue = cleanString(value);
                                change('vin', cleanedValue);
                                if (cleanedValue !== value) {
                                  setTimeout(() => {
                                    createEditAssetFormRef.setValues({ vin: cleanedValue });
                                  }, 100);
                                }
                              }}
                              maxLength={17}
                              buttonText={messages['manage_createEditAsset_decodeVIN']}
                              onClick={() => {
                                const values = createEditAssetFormRef?.ref?.current?.getValues();
                                if (values?.vin) {
                                  dispatch(assetDecodeVin({ vin: values?.vin }));
                                }
                              }}
                              className="asset-vin-input"
                            />
                          </Form.Item>
                          <CounterString string={formData?.vin || ''} maxLength={17} />
                
                          <Form.Item
                            name="make"
                            label={messages['manage_createEditAsset_make']}
                            className="asset-formItem"
                            rules={[{ required: isRequired('make'), message: messages['required_field'] }]}
                          >
                            <Input
                              id="make"
                              type="text"
                              placeholder={messages['manage_createEditAsset_make']}
                              onChange={(value) => {
                                const cleanedValue = cleanString(value);
                                change('make', cleanedValue);
                                if (cleanedValue !== value) {
                                  setTimeout(() => {
                                    createEditAssetFormRef.setValues({ make: cleanedValue });
                                  }, 100);
                                }
                              }}
                              maxLength={30}
                            />
                          </Form.Item>
                          <CounterString string={formData?.make || ''} maxLength={30} />
                
                          <Form.Item
                            name="model"
                            label={messages['manage_createEditAsset_model']}
                            className="asset-formItem"
                            rules={[{ required: isRequired('model'), message: messages['required_field'] }]}
                          >
                            <Input
                              id="model"
                              type="text"
                              placeholder={messages['manage_createEditAsset_model']}
                              onChange={(value) => {
                                const cleanedValue = cleanString(value);
                                change('model', cleanedValue);
                                if (cleanedValue !== value) {
                                  setTimeout(() => {
                                    createEditAssetFormRef.setValues({ model: cleanedValue });
                                  }, 100);
                                }
                              }}
                              maxLength={50}
                            />
                          </Form.Item>
                          <CounterString string={formData?.model || ''} maxLength={50} />
                
                          <Form.Item
                            name="year"
                            label={messages['manage_createEditAsset_year']}
                            rules={[
                              { max: nextYear, message: `${messages['manage_createEditAsset_maxValue']}: ${nextYear}` },
                              { min: 1980, message: `${messages['manage_createEditAsset_minValue']}: 1980` },
                              { required: isRequired('year'), message: messages['required_field'] },
                            ]}
                            className="asset-formItem"
                          >
                            <InputNumeric
                              id="year"
                              type="number"
                              isInteger
                              placeholder={messages['manage_createEditAsset_year']}
                              onChange={(value) => {
                                const n = Math.abs(Number(value));
                                change('year', n);
                              }}
                              maxLength={4}
                              onlyPositive
                              min={1980}
                              max={nextYear}
                            />
                          </Form.Item>
                          <CounterString string={formData?.year || ''} maxLength={4} />
                
                          {!['TRAILER', 'DOLLY'].includes(formData?.assetType?.label?.toUpperCase()) && (
                            <>
                              <Form.Item
                                name="engine"
                                label={messages['manage_createEditAsset_engineLiters']}
                                rules={[
                                  { max: 10000, message: `${messages['max']}: 10000` },
                                  { required: isRequired('engine'), message: messages['required_field'] },
                                ]}
                                className="asset-formItem"
                              >
                                <InputNumeric
                                  id="engine"
                                  type="number"
                                  placeholder={messages['manage_createEditAsset_engineLiters']}
                                  onChange={(value) => {
                                    const n = parseFloat(String(value));
                                    const normalized = !isFinite(n) || n <= 0 ? null : n;
                                    change('engine', normalized);
                                  }}
                                  maxLength={5}
                                  onlyPositive
                                  decimalPlaces={2}
                                />
                              </Form.Item>
                              <CounterString string={formData?.engine || ''} maxLength={5} />
                            </>
                          )}
                        </>
                      )}
                
                      {isVisible(sections.MPG) && (
                        <>
                          {!['TRAILER', 'DOLLY'].includes(formData?.assetType?.label?.toUpperCase()) && (
                            <>
                              <span style={{ fontWeight: 500, fontSize: 15 }}>{messages['manage_createEditAsset_mpg']}</span>
                              <Divider style={{ marginBottom: 10 }} />
                    
                              <Form.Item
                                name="mpgHighway"
                                label={messages['manage_createEditAsset_highway']}
                            rules={[
                              { max: 200, message: `${messages['max']}: 200` },
                              { required: isRequired('mpgHighway'), message: messages['required_field'] },
                            ]}
                            className="asset-formItem"
                          >
                            <InputNumeric
                              id="mpgHighway"
                              type="number"
                              isInteger
                              placeholder={messages['manage_createEditAsset_highway']}
                              onChange={(value) => {
                                const n = Math.abs(Number(value));
                                change('mpgHighway', n);
                              }}
                              maxLength={3}
                              onlyPositive
                            />
                          </Form.Item>
                          <CounterString string={formData?.mpgHighway || ''} maxLength={3} />
                
                          <Form.Item
                            name="mpgCity"
                            label={messages['manage_createEditAsset_city']}
                            rules={[
                              { max: 200, message: `${messages['max']}: 200` },
                              { required: isRequired('mpgCity'), message: messages['required_field'] },
                            ]}
                            className="asset-formItem"
                          >
                            <InputNumeric
                              id="mpgCity"
                              type="number"
                              isInteger
                              placeholder={messages['manage_createEditAsset_city']}
                              onChange={(value) => {
                                const n = Math.abs(Number(value));
                                change('mpgCity', n);
                              }}
                              maxLength={3}
                              onlyPositive
                            />
                              </Form.Item>
                              <CounterString string={formData?.mpgCity || ''} maxLength={3} />
                            </>
                          )}
                        </>
                      )}
                
                      {isVisible(sections.EVIR) && (
                        <>
                          {HasPermission(user, 'evir') ? (
                            <>
                              <span style={{ fontWeight: 500, fontSize: 15 }}>{messages['manage_createEditAsset_evir']}</span>
                              <Divider style={{ marginBottom: 10 }} />
                
                              <Form.Item
                                name="inspectionDeviceType"
                                label={messages['manage_createEditAsset_inspectionDeviceType']}
                                rules={[{ required: isRequired('inspectionDeviceType'), message: messages['required_field'] }]}
                              >
                                <Select
                                  id="inspectionDeviceType"
                                  options={entityLists?.filter((item) => item?.entityName === 'InspectionDeviceType') || []}
                                  placeholder={messages['select']}
                                  valueField="entityId"
                                  textField="label"
                                  style={{ width: '100%', fontFamily: '"Outfit", sans-serif' }}
                                  isSearchable
                                  isLoading={loadingEntityLists}
                                  onChange={(value) => change('inspectionDeviceType', value)}
                                  isClearable
                                />
                              </Form.Item>
                
                              <Form.Item
                                name="inspectionTagId"
                                label={messages['manage_createEditAsset_inspectionTagId']}
                                className="asset-formItem"
                                rules={[
                                  { required: isRequired('inspectionTagId'), message: messages['required_field'] },
                                  { min: 1, message: messages['manage_createEditAsset_minValue'] ? `${messages['manage_createEditAsset_minValue']}: 1` : 'Minimum value: 1' },
                                  { max: 999999999, message: messages['max'] ? `${messages['max']}: 999,999,999` : 'Maximum value: 999,999,999' }
                                ]}
                              >
                                <InputNumeric
                                  id="inspectionTagId"
                                  type="number"
                                  placeholder={messages['manage_createEditAsset_inspectionTagId']}
                                  onChange={(value) => {
                                    const n = Math.abs(Number(value));
                                    change('inspectionTagId', n);
                                  }}
                                  maxLength={9}
                                  onlyPositive
                                  min={1}
                                  max={999999999}
                                />
                              </Form.Item>
                              <CounterString string={formData?.inspectionTagId || ''} maxLength={9} />
                            </>
                          ) : null}
                        </>
                      )}
                
                      {isVisible(sections.ZONAR_ELD) && (
                        <>
                          {HasPermission(user, 'zlogs') ? (
                            <>
                              <span style={{ fontWeight: 500, fontSize: 15 }}>Zonar ELD</span>
                              <Divider style={{ marginBottom: 10 }} />
                              <div style={{ height: 100 }}>
                                <Form.Item
                                  name="powerUnitNumber"
                                  label={messages['manage_createEditAsset_powerUnitNumber']}
                                  rules={[{ required: isRequired('powerUnitNumber'), message: messages['required_field'] }]}
                                  className="asset-formItem"
                                >
                                  <Input
                                    id="powerUnitNumber"
                                    type="text"
                                    placeholder={messages['manage_createEditAsset_powerUnitNumber']}
                                    onChange={(value) => {
                                      const cleanedValue = cleanString(value);
                                      change('powerUnitNumber', cleanedValue);
                                      if (cleanedValue !== value) {
                                        setTimeout(() => {
                                          createEditAssetFormRef.setValues({ powerUnitNumber: cleanedValue });
                                        }, 100);
                                      }
                                    }}
                                    maxLength={10}
                                  />
                                </Form.Item>
                                <CounterString string={formData?.powerUnitNumber || ''} maxLength={10} />
                              </div>
                            </>
                          ) : null}
                        </>
                      )}
                    </div>
            ),
        },
        {
            label: messages["manage_createEditAsset_tags"],
            icon: "local_offer",
            component: (
                <div>
                    <TagsManage
                      disableUntaggedSelection={false}
                      enableSelectAll={false}
                      value={formData?.tags || []}
                      onChange={(value) => {
                        setFormData({ ...formData, tags: value });
                        setChanges({ ...changes, tags: true })
                      }}
                      multiple={true}
                      required={false}
                      label={messages["unit_settings_tags"]}
                      onlyTags={true}
                      mode="selector"
                      isVisiblePill={true}
                      menuStyle={{ maxHeight: '250px', maxWidth: '298px', overflowY: 'auto' }}
                    />
                </div>
            ),
        }
    ];

    const maxTabIndex = tabs.length - 1;
    const safeTab = typeof tab === "number" && tab >= 0 && tab <= maxTabIndex ? tab : 0;

    

    return (
        <Modal
            title={!assetId ? messages['manage_createEditAsset_createAsset'] : `${messages['manage_createEditAsset_asset']} ${asset?.label ? `- ${asset?.label}` : ""}`}
            size="small"
            open={open}
            handleClose={handleClose}
            loading={loading || loadingAsset || loadingDecodeVin || loadingAssetTypeConfig}
            footer={
                <div>
                    <Button
                        variant="secondary"
                        style={{ marginRight: "5px" }}
                        onClick={() => handleClose()}
                        isDisabled={loading}
                    >
                        {messages["cancel"]}
                    </Button>
                    <Button
                        variant="primary"
                        onClick={() => createEditAssetFormRef?.submit()}
                        isDisabled={loading}
                    >
                        {messages["save"]}
                    </Button>
                </div>
            }
        >
            <div style={{ padding: "0 24px" }}>
                <Form
                    ref={createEditAssetFormRef.ref}
                    loading={loading}
                    onValidSubmit={(values) => {
                        handleSubmit(values)
                    }}
                    onSubmit={(values, values1) => {
                        if (typeof values1 === 'object' && values1 !== null && Object.keys(values1).length > 0) {
                            NotificationManager.info(
                                messages["manage_createEditAsset_requiredFields"],
                                messages["manage_createEditAsset_alert_title"],
                                5000
                            );
                        }
                    }}
                >

                     <Tabs
                            tab={safeTab}
                            type="icon-indicator"
                            border
                            onChange={(value) => setTab(value)}
                        >
                            {tabs.map((item, index) => {
                                const { label, component, icon } = item;
                                return (
                                    <TabContainer key={index} label={label} index={index} iconIndicator={icon} style={{ padding: '24px 0' }}>
                                        {component}
                                    </TabContainer>
                                );
                            })}
                        </Tabs>
                </Form>
            </div>
            <NotificationContainer />
        </Modal>
    );
};

export default CreateEditAsset;
